import { Row, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  getAllMasterEvents,
  getEventAttendanceCount,
  getEventAttendances,
} from '../../api/event.api'
import ContentHeader from '../../components/shared/ContentHeader'
import styles from '../../styles/sales.module.scss'

const EventSnsPage = () => {
  const [eventAttendances, setEventAttendances] = useState({
    content: [],
    pageable: { pageNumber: 0, pageSize: 10 },
    totalElements: 0,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [eventList, setEventList] = useState(null)
  const [statusFilter, setStatusFilter] = useState(null)
  const navigate = useNavigate()
  const [attendanceCounts, setAttendanceCounts] = useState({})

  useEffect(() => {
    getEvents(0, eventAttendances.pageable?.pageSize, statusFilter)
    // eslint-disable-next-line
  }, [statusFilter])

  useEffect(() => {
    getArticleEventInfo()
  }, [])

  // 참여수 비동기 집계
  useEffect(() => {
    const fetchCounts = async () => {
      if (!eventList || !Array.isArray(eventList)) return
      const newCounts = {}
      await Promise.all(
        eventList.map(async (item) => {
          try {
            const count = await getEventAttendanceCount(item.id)
            newCounts[item.id] = count
          } catch {
            newCounts[item.id] = 0
          }
        }),
      )
      setAttendanceCounts(newCounts)
    }
    fetchCounts()
  }, [eventList])

  // page, size, status를 받아서 서버에서 데이터 요청
  const getEvents = async (page = 0, size = 10, status = statusFilter) => {
    setIsLoading(true)
    const params = {
      page,
      size,
      status, // null(전체), 'REJECTED', 'APPROVED', 'REQUESTED'
    }
    try {
      const res = await getEventAttendances(params)
      setEventAttendances(res.data)
    } catch (err) {
      console.log('getPrograms err', err)
    } finally {
      setIsLoading(false)
    }
  }

  const getArticleEventInfo = async () => {
    // 1번은 무조건 아티클
    try {
      const res = await getAllMasterEvents()
      setEventList(res.data)
    } catch (error) {
      console.log('getArticleEventInfo err', error)
      return null
    }
  }

  // const getEventAttendanceCount = async (eventId) => {
  //   const res = await getEventAttendances({ eventId })
  //   return res.data
  // }

  return (
    <>
      <ContentHeader title="[혜택] SNS 이벤트 관리" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }}
      >
        {/* 상태 필터 드롭박스 */}
        <div
          style={{
            margin: '16px 0',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        ></div>

        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <span className={`${styles['product-register-box-title']}`}>
            인스타 아티클 게시물 관리
          </span>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          {eventList && Array.isArray(eventList) && (
            <Table
              dataSource={eventList}
              rowKey="id"
              pagination={false}
              bordered
              onRow={(record) => ({
                onClick: () => navigate(`/event/sns/edit/${record.id}`),
                style: { cursor: 'pointer' },
              })}
              columns={[
                {
                  title: 'ID',
                  dataIndex: 'id',
                  key: 'id',
                  width: 60,
                  align: 'center',
                },
                {
                  title: '참여수',
                  dataIndex: 'attendanceCount',
                  key: 'attendanceCount',
                  width: 150,
                  align: 'center',
                  render: (text, record) => {
                    const count = attendanceCounts[record.id]
                    // console.log(count, 'count')
                    return typeof count === 'number' && count > 0 ? (
                      <b>{count?.toLocaleString()}</b>
                    ) : (
                      <span>-</span>
                    )
                  },
                },
                {
                  title: '이벤트명',
                  dataIndex: 'title',
                  key: 'title',
                  render: (text) => <b>{text}</b>,
                },
                {
                  title: '설명',
                  dataIndex: 'description',
                  key: 'description',
                },
                {
                  title: '타입',
                  dataIndex: 'eventType',
                  key: 'eventType',
                  width: 100,
                  fontSize: 12,
                  align: 'center',
                },
              ]}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default EventSnsPage
